export class LoginData {
    position: any;
    userName : any;
    group: any;
    details: any;
}
